import type { Address, AxiosRequestConfig } from '@ahm/api-wrappers-core';

export interface AutocompleteData {
  features: unknown[];
  source_list?: string[];
  type?: string;
}

export type AutocompleteParams = {
  input: string;
  lat?: number;
  lng?: number;
  mode?: string;
};

export const getAutocompleteFn = async (
  requestParams: AutocompleteParams,
  config: AxiosRequestConfig = {}
): Promise<Address[]> => {
  const { input, lat, lng } = requestParams;

  const params = new URLSearchParams({ input });
  if (lat) params.set('lat', String(lat));
  if (lng) params.set('lng', String(lng));

  try {
    const res = await fetch(`/api/address/autocomplete?${params.toString()}`, {
      signal: config.signal as AbortSignal | undefined,
    });
    if (!res.ok) return [];
    return (await res.json()) as Address[];
  } catch {
    return [];
  }
};
